<template>
  <div class="policy">
    <div class="policy-source">
      <span class="policy-tit">政策来源：</span>
      <el-menu ref="policyTit" active-text-color="#3056D9" text-color="#000" :default-active="activeIndex" mode="horizontal"
        @select="handleSelect" style="margin-top: 2px">
        <el-menu-item v-for="item in policySource" :key="item.index" :index="item.index">
          {{ item.source }}
        </el-menu-item>
      </el-menu>
      <div class="navSearchWpBox">
        <el-divider direction="vertical"></el-divider>
        <div class="navSearchWp">
          <el-dropdown class="more" placement="bottom-start" @command="handleCommand" trigger="click" v-if="country !== '国家政策' && country !== null">
            <span class="el-dropdown-link">
              更多<i class="el-icon-caret-bottom"></i>
            </span>
            <el-dropdown-menu class="more-option" slot="dropdown" style="width: 200px; height: 210px; overflow-y: scroll">
              <el-dropdown-item v-for="item in morePolicySource" :key="item.index" :command="item.source">
                {{ item.source }}
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <el-dropdown class="more" placement="bottom-start" @command="handleCommand1" trigger="click" v-if="country !== '地方政策' && country !== null">
            <span class="el-dropdown-link">
              更多<i class="el-icon-caret-bottom"></i>
            </span>
            <el-dropdown-menu class="more-option" slot="dropdown" style="width: 200px; height: 210px; overflow-y: scroll">
              <el-dropdown-item v-for="item in morePolicyCountry" :key="item.label" :command="item.value">
                {{ item.label }}
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <el-input disabled style="width: 200px; margin-left: 10px" v-model="resource"></el-input>
        </div>
      </div>
    </div>

    <time-inquire ref="timeInquire" :typeName="typeName" @updateList="refreshPolicyData" @changeStartTime="UpdateStartTime"
      @changeEndTime="UpdateEndTime">
    </time-inquire>
    <content-inquire @resetData="resetPolicyList" @referData="keyWordRefer"></content-inquire>
    <el-divider></el-divider>

    <div>
      <p class="content-num">当前共{{ totalNum }}条</p>
      <information-content :infomationContent="policyContent" :goDetailPath="detailPath" :pageType="typeName" :time="time">
      </information-content>
    </div>

    <paging :totalPage="totalNum" :pageSize="size" :CurrentPage="page" @curentPage="handleCurrentChange">
    </paging>
    <return-top></return-top>
  </div>
</template>

<script>
  import TimeInquire from '@/components/information/timeInquire.vue'
  import ContentInquire from '@/components/information/contentInquire.vue'
  import InformationContent from '@/components/information/information-content.vue'
  import Paging from '@/components/paging.vue'
  import ReturnTop from '@/components/returnTop.vue'

  export default {
    name: 'policy',
    props: {},
    components: {
      TimeInquire,
      ContentInquire,
      InformationContent,
      Paging,
      ReturnTop
    },
    data() {
      return {
        typeName: 'policy',
        detailPath: '/policyDetail',
        activeIndex: '1',
        policySource: [{
            source: '全部',
            index: '1'
          },
          {
            source: '国家政策',
            index: '2'
          },
          {
            source: '地方政策',
            index: '3'
          }
          // { source: '人社部', index: '2' },
          // { source: '中组部', index: '3' },
          // { source: '教育部', index: '4' },
          // { source: '科技部', index: '5' },
          // { source: '发改委', index: '6' },
          // { source: '工信部', index: '7' }
        ], // 政策来源
        morePolicySource: [{
            source: '山西省',
            index: '1'
          },
          {
            source: '内蒙古自治区',
            index: '2'
          },
          {
            source: '辽宁省',
            index: '3'
          },
          {
            source: '黑龙江省',
            index: '4'
          },
          {
            source: '上海市',
            index: '5'
          },
          {
            source: '江苏省',
            index: '6'
          },
          {
            source: '浙江省',
            index: '7'
          },
          {
            source: '安徽省',
            index: '8'
          },
          {
            source: '福建省',
            index: '9'
          },
          {
            source: '江西省',
            index: '10'
          },
          {
            source: '山东省',
            index: '11'
          },
          {
            source: '河南省',
            index: '12'
          },
          {
            source: '湖北省',
            index: '13'
          },
          {
            source: '湖南省',
            index: '14'
          },
          {
            source: '广东省',
            index: '15'
          },
          {
            source: '广西壮族自治区',
            index: '16'
          },
          {
            source: '海南省',
            index: '17'
          },
          {
            source: '重庆市',
            index: '18'
          },
          {
            source: '四川省',
            index: '19'
          },
          {
            source: '贵州省',
            index: '20'
          },
          {
            source: '云南省',
            index: '21'
          },
          {
            source: '西藏自治区',
            index: '22'
          },
          {
            source: '陕西省',
            index: '23'
          },
          {
            source: '甘肃省',
            index: '24'
          },
          {
            source: '宁夏回族自治区',
            index: '25'
          },
          {
            source: '新疆维吾尔自治区',
            index: '26'
          },
          {
            source: '新疆建设兵团',
            index: '27'
          },
          {
            source: '北京市',
            index: '28'
          },
          {
            source: '天津市',
            index: '29'
          },
          {
            source: '河北省',
            index: '30'
          },
          {
            source: '青海省',
            index: '31'
          }
        ],
        morePolicyCountry: [{
            value: '中共中央国务院',
            label: '中共中央国务院'
          },
          {
            value: '中组部',
            label: '中组部'
          },
          {
            value: '教育部',
            label: '教育部'
          },
          {
            value: '科技部',
            label: '科技部'
          },
          {
            value: '工信部',
            label: '工信部'
          },
          {
            value: '公安部',
            label: '公安部'
          },
          {
            value: '财政部',
            label: '财政部'
          },
          {
            value: '人社部',
            label: '人社部'
          },
          {
            value: '海关总署',
            label: '海关总署'
          },
          {
            value: '国家知识产权局',
            label: '国家知识产权局'
          }
          // {
          //   value: '人社部',
          //   label: '人社部'
          // },
          // {
          //   value: '中组部',
          //   label: '中组部'
          // },
          // {
          //   value: '教育部',
          //   label: '教育部'
          // },
          // {
          //   value: '科技部',
          //   label: '科技部'
          // },
          // {
          //   value: '发改委',
          //   label: '发改委'
          // },
          // {
          //   value: '工信部',
          //   label: '工信部'
          // }
        ],
        policyContent: [],
        time: '', // 发文时间
        totalNum: 0, // 总数据条数
        page: 1, // 默认页码
        size: 10, // 每页数据条数
        startTime: null, // 开始时间
        endTime: null, // 结束时间
        country: null, // 发文地区
        resource: null, // 政策来源
        detail: null // 搜索关键字
      }
    },
    computed: {},
    created() {
      this.getPolicyData()
    },
    mounted() {
      document.documentElement.scrollTop = 0

      this.$parent.activeIndex = '9'
    },
    methods: {
      // 根据政策来源渲染数据
      handleSelect(key, keyPath) {
        switch (key) {
          // case '2':
          //   this.resource = '人社部'
          //   this.getPolicyData()
          //   break
          // case '3':
          //   this.resource = '中组部'
          //   this.getPolicyData()
          //   break
          // case '4':
          //   this.resource = '教育部'
          //   this.getPolicyData()
          //   break
          // case '5':
          //   this.resource = '科技部'
          //   this.getPolicyData()
          //   break
          // case '6':
          //   this.resource = '发改委'
          //   this.getPolicyData()
          //   break
          // case '7':
          //   this.resource = '工信部'
          //   this.getPolicyData()
          //   break
          // case '8':
          //   this.resource = '北京市'
          //   this.getPolicyData()
          //   break
          // case '9':
          //   this.resource = '天津市'
          //   this.getPolicyData()
          //   break
          // case '10':
          //   this.resource = '河北省'
          //   this.getPolicyData()
          //   break
          // case '11':
          //   this.resource = '青海省'
          //   this.getPolicyData()
          //   break
          case '2':
            this.resource = '国家政策'
            this.getPolicyData()
            break
          case '3':
            this.resource = '地方政策'
            this.getPolicyData()
            break
          default:
            this.resource = null
            this.country = null
            this.getPolicyData()
            break
        }
      },
      handleCommand(command) {
        this.page = 1
        this.morePolicySource.forEach((element) => {
          if (element.source === command) {
            this.resource = command
            this.getPolicyData()
          }
        })
      },
      handleCommand1(command) {
        this.page = 1
        this.morePolicyCountry.forEach((element) => {
          if (element.value === command) {
            this.resource = command
            this.getPolicyData()
          }
        })
      },
      // 获取政策数据
      async getPolicyData() {
        if (this.resource === '国家政策') {
          this.country = '国家政策'
          this.resource = null
        }
        if (this.resource === '地方政策') {
          this.country = '地方政策'
          this.resource = null
        }
        try {
          const res = await this.$get(this.$url.policy.policyData, {
            page: this.page,
            size: this.size,
            startTime: this.startTime,
            endTime: this.endTime,
            resource: this.country,
            publishOrg: this.resource,
            detail: this.detail
          })
          const {
            code,
            msg,
            data
          } = res.data
          if (code === 200 && data) {
            this.policyContent = data.records
            this.totalNum = data.total
          } else {
            this.$message.error(msg)
          }
          // console.log(res.data)
        } catch (err) {
          console.log(err)
        }
      },

      // 按固定发文天数刷新数据
      refreshPolicyData(key) {
        const date = new Date()
         this.page = 1
        switch (key) {
          case '2':
            this.startTime = date.getFullYear() + '-' + '01' + '-' + '01' // 今年
            this.endTime =
              date.getFullYear() +
              '-' +
              '0' +
              (date.getMonth() + 1) +
              '-' +
              date.getDate()
            // //   console.log(this.startTime)
            // //   console.log(this.endTime)
            // this.yearType = 1
            this.getPolicyData()
            break
          case '3':
            this.startTime = date.getFullYear() - 1 + '-' + '01' + '-' + '01' // 去年
            this.endTime = date.getFullYear() - 1 + '-' + '12' + '-' + '30'
            // this.yearType = 2
            this.getPolicyData()
            break
          default:
            this.startTime = null
            this.endTime = null
            this.getPolicyData()
            break
        }
      },

      // 自定义更新数据
      UpdateStartTime(start) {
        this.startTime = start
      },
      UpdateEndTime(end) {
        this.endTime = end
        this.$refs.policyTit.activeIndex = '1'
        this.getPolicyData()
      },

      // 关键字查询
      keyWordRefer(kWord) {
        this.detail = kWord
        this.page = 1
        this.getPolicyData()
      },

      // 重置
      resetPolicyList() {
        this.startTime = null
        this.endTime = null
        this.detail = null
        this.resource = null
        this.country = null
        this.$refs.timeInquire.changeNum()
        // this.$refs.timeInquire.Aindex = '1'
        this.$refs.policyTit.activeIndex = '1'
        this.getPolicyData()
      },

      // 分页功能
      handleCurrentChange(page) {
        this.page = page
        this.getPolicyData()
      }
    }
  }
</script>

<style scoped lang="less">
  .policy {
    width: 1200px;
    min-height: 100vh;
    font-size: 16px;
    margin: 12px auto 0;
    overflow: hidden;
  }

  .policy-source {
    display: flex;
    margin-top: 30px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #000;

    // margin-bottom: 35px;
    .navSearchWpBox {
      display: flex;
      padding-bottom: 10px;
      overflow: hidden;

      .navSearchWp {
        padding-bottom: 10px !important;

        .more {
          margin-top: 20px;
          position: relative;

          .el-dropdown-link {
            font-size: 14px !important;
          }

          .more-option {
            position: absolute;
            background-color: #000;
            top: 350px;
            width: 100px;
            height: 50px !important;
            overflow: scroll;
          }
        }
      }
    }

    .policy-tit {
      margin-top: 20px;
    }

    /deep/.el-menu--horizontal {
      font-size: 14px;
      border-bottom: 0;
    }

    /deep/.el-menu-item {
      padding: 0 25px;
      height: 0;
      line-height: 35px;
      margin-top: 8px;
    }

    /deep/.is-active {
      border-bottom-color: transparent !important;
      color: #fff;
    }

    /deep/.el-divider {
      height: 15px;
      width: 2px;
      margin: 20px 40px 0 15px;
    }
  }

  .content-num {
    font-size: 14px;
    color: #3056d9;
    margin: 20px 0;
  }

  // /deep/.el-dropdown-menu{
  //   background-color: #000 !important;
  //   width: 80px;height: 100px;
  //   overflow-y: scroll;
  // }
</style>
